import { API_JWT_TOKEN_NAME, CALL_API } from '../middleware/api'

export const BUSINESS_TX_STATE_UPDATE_REQUEST = 'BUSINESS_TX_STATE_UPDATE_REQUEST'
export const BUSINESS_TX_STATE_UPDATE_SUCCESS = 'BUSINESS_TX_STATE_UPDATE_SUCCESS'
export const BUSINESS_TX_STATE_UPDATE_FAILURE = 'BUSINESS_TX_STATE_UPDATE_FAILURE'

export function businessUpdateTxState(id, stateName, body) {
  return {
    [CALL_API]: {
      endpoint: '/api/business/businesses/' + id + '/make-' + stateName + '/',
      types: [BUSINESS_TX_STATE_UPDATE_REQUEST, BUSINESS_TX_STATE_UPDATE_SUCCESS, BUSINESS_TX_STATE_UPDATE_FAILURE],
      method: 'PUT',
      body,
      tokenType: API_JWT_TOKEN_NAME,
    },
  }
}
